module.exports = __webpack_public_path__ + "static/media/homer.a5276434.jpg";